/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import SkeletonHeadingItem from '@atlaskit/menu/skeleton-heading-item';
import SkeletonItem from '@atlaskit/menu/skeleton-item';
import { testIdConcat } from '@jira/navigation-apps__common/src/utils/test-id.tsx';
import type { MenuSkeletonContentProps } from './types.tsx';

export const MenuSkeletonContent = ({
	testIdPrefix,
}: MenuSkeletonContentProps): React.JSX.Element => (
	<div data-testid={testIdConcat(testIdPrefix, 'skeleton')}>
		<SkeletonHeadingItem />
		<SkeletonItem hasIcon width="62.5%" />
		<SkeletonItem hasIcon width="50%" />
		<SkeletonItem hasIcon width="62.5%" />
		<SkeletonItem hasIcon width="50%" />
	</div>
);
